import React from 'react';
import type { GuestSiteComponentProps } from '@apps/websiteCustomJsonComponents/JsonComponent.types';
import { DefaultThingsToDoGuest as DefaultThingsToDoGuestOriginal } from '@apps/websiteCustomJsonComponents/customComponents/DefaultThingsToDo/DefaultThingsToDoGuest';
import { LazyDefaultThingsToDoHoneymoon } from './DefaultThingsToDoHoneymoon.lazy';
import { useIsStaysRedesignActive } from './useIsStaysRedesignActive';

/**
 * Dispatcher for the stays-page redesign experiment. Re-exports under the
 * original `DefaultThingsToDoGuest` name so the upstream `.lazy.ts` file
 * (and webpack chunk name) stays unchanged.
 */
export const DefaultThingsToDoGuest = (props: GuestSiteComponentProps) => {
  const isRedesignActive = useIsStaysRedesignActive();
  return isRedesignActive ? <LazyDefaultThingsToDoHoneymoon {...props} /> : <DefaultThingsToDoGuestOriginal {...props} />;
};
